module.exports = __webpack_public_path__ + "img/folder-icon.e85f6d67.svg";